import React, { useState, useEffect } from "react";
import { Flex, Table, Tooltip, message, Avatar } from "antd";
import { useSpin } from "../../components/SpinContext.js";
import { useToken } from "../../common/helper/index.js";
import {
  CustomParagraph,
  CustomTitle,
  AddItemButton,
  CustomModalWithoutButton,
} from "../../components/index.js";
import deleteIcon from "../../assets/images/delete.svg";
import { getSensorsDDL, getTeamsDDL } from "../../common/utils/dropDown";
import editIcon from "../../assets/images/edit-icon.svg";
import StatusTag from "../../components/StatusTag.jsx";
import TeamsTag from "../../components/TeamsTag.jsx";
import CommonDrawer from "../../components/CommonDrawer.jsx";
import CustomDeleteModal from "../Modals/CustomDeleteModal.jsx";
import SensorForm from "./SensorForm.jsx";
import {
  DeleteCompanySensor,
  GetCompanySensors,
} from "../../api's/settings.js";
import SensorProviderDetails from "./SensorProviderDetails.jsx";
import {  useSelector } from "react-redux";
import SensorConnectionModal from "../Modals/SensorConnectionModal.jsx";
import TeamBadge from "../../components/TeamBadge.jsx";
import Img from "../../assets/images/default icon.png";
import { getProviderImagePath } from "../../common/utils/imageUtils";
import ZLShield from '../../assets/images/ZLshield.png';
import Arrows from '../../assets/images/arrows.png';
import { getPermissions } from "../../common/helper/getPermissions.js";

const Sensors = ({ title }) => {
  const { token } = useToken();
  const [showProviderDetails, setShowProviderDetails] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const { showSpin, hideSpin } = useSpin();
  const [sensorList, setSensorList] = useState([]);
  const allTeams = useSelector((state) => state.teams.list);
  const [sensorFormList, setSensorFormList] = useState([]);
  const [sensor_id, setSensorsId] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [companySensorsLoading, setCompanySensorsLoading] = useState(true);
  const [sensorDDLLoading, setSensorDDLLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
   const main_menu = useSelector((state) => state.menu.items);
    const SensorsPermissions = getPermissions(main_menu, "Settings", "Sensors");
  const [sensorData, setSensorsData] = useState({
    imgSrc: "",
    descrption: null,
  });
  const [modalState, setModalState] = useState({
    delete: false,
    connection: false,
  });

  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [selectedSensor, setSelectedSensor] = useState(null);
  const [credentials, setCredentials] = useState(
    selectedSensor?.credential || null
  );

  useEffect(() => {
    handleFetchComapnaySensors();
  }, [token]);


  const handleFetchComapnaySensors = () => {
    setCompanySensorsLoading(true);
    GetCompanySensors(token)
      .then((res) => {
        const data = res?.data || null;
        if (data?.data?.is_success) {
          if(data?.data?.data?.length>0){
            setSensorList(data.data.data);
          }else{
            setSensorList([])
          }
          
        } else {
          message.error(data?.data?.message || "Failed to fetch sensors.");
        }
        setCompanySensorsLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching sensors:", err);
        setCompanySensorsLoading(false);
      });
  };

  useEffect(() => {
    setSensorDDLLoading(true);
    getSensorsDDL(token)
      .then((val) => {
        if (val && Array.isArray(val)) {
          setSensorDDLLoading(false);
          setSensorFormList(val);
        }
      })
      .finally(() => {
        setSensorDDLLoading(false);
      });
  }, [token]);

  const handleDeleteClick = (sensor) => {
    setSelectedSensor(sensor);
    setDeleteModalVisible(true);
  };

  const handleConfirmDelete = () => {
    if (selectedSensor && selectedSensor.sensor_id) {
      DeleteCompanySensor(selectedSensor?.id, token)
        .then((res) => {
          const data = res?.data || null;
          if (data) {
            if (data.data?.is_success) {
              message.success(data?.data?.message);
              setDeleteModalVisible(false);
              setModalState((prev) => ({ ...prev, delete: false }));
              handleCloseDrawer ();
            } else {
              message.error(data?.data?.message);
            }
          }
        })
        .catch((error) => {
          hideSpin();
        });
    }
  };

  const handleEdit = (record) => {
    setSelectedSensor(record);
    setShowProviderDetails(true);
    setIsEditing(true);
    setDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setModalOpen(false);
    setDrawerOpen(false);
    setSelectedSensor(null);
    setShowProviderDetails(false);
    setSearchQuery("");
    handleFetchComapnaySensors();
  };

  const handleSuccess = (data) => {
    setModalState((prev) => ({ ...prev, connection: false }));

    setCredentials((prev) => ({ ...prev, ...data }));
    setSelectedSensor((prev) => ({ ...prev, ...data }));

    setModalOpen(false);
    setSensorsId(null);
    setShowProviderDetails(true);
  };

  const handleButtonClick = (item) => {
    if (item) {
      setSensorsId(item.id);
      setSensorsData(item);
    }
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalState((prev) => ({ ...prev, connection: false }));

    setModalOpen(false);
    setSensorsId(null);
    setSensorsData({ imgSrc: "", description: "" });
  };

  const handleAddProvider = () => {
    setSelectedSensor(null);
    setIsEditing(false);
    setShowProviderDetails(false);
    setDrawerOpen(true);
  };

  const columns = [
    {
      title: "Sensor",
      dataIndex: "sensor_name",
      key: "sensor_name",
      width:"200px",
      render: (text) => (
        <CustomParagraph
          text={text || "--"}
          fontSize={14}
          fontWeight={600}
          color="#000"
        />
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text) => (
        <CustomParagraph
          text={text}
          noText="--"
          fontSize={14}
          fontWeight={400}
          color="#000"
        />
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => <StatusTag status={status} />,
    },
    {
      title: "Team",
      dataIndex: "teams",
      key: "teams",
      render: (_, record) => {
        return (
          <>
            {record?.teams?.length > 0 ? (
              <div className="flex gap-x-2">
                <TeamBadge
                  color={record?.teams[0]?.color}
                  text={`${record?.teams[0]?.name}`}
                  tooltipText={`${record?.teams[0]?.name}`}
                />
                {record?.teams.length > 1 && (
                  <Tooltip
                    title={record?.teams?.slice(1)
                      .map((team) => team.name)
                      .join(", ")}
                    placement="top"
                  >
                    <div
                      style={{
                        display: "inline-block",
                        cursor: "pointer",
                      }}
                    >
                      <TeamBadge
                        color={null}
                        text={`+ ${record?.teams?.length - 1}`}
                      />
                    </div>
                  </Tooltip>
                )}
              </div>
            ) : (
              <p>--</p>
            )}
          </>
        );
      },
    },
    {
      title: "",
      key: "action",
      render: (_, record) => (
        <Flex
          justify="center"
          align="center"
          style={{ width: "42px", gap: "30px", cursor: "pointer" }}
        >
          {record?.permissions?.is_update &&
          <img src={editIcon} alt="Edit" onClick={() => handleEdit(record)} />
          }
         {record?.permissions?.is_delete &&
          <img src={deleteIcon} alt="Delete" onClick={() => handleDeleteClick(record)}/>
         }
        </Flex>
      ),
    },
  ];

  const TeamsFilteredColumns =
    allTeams?.length > 0
      ? columns
      : columns.filter((column) => column.key !== "teams");

  return (
    <>
      <div className="settings-content-wrapper">
        <CustomTitle
          text={`${title} (${sensorList.length})`}
          fontSize={20}
          fontWeight="700"
          lineHeight="32px"
          color="#000"
          marginBottom={0}
        />

        <Table
          columns={TeamsFilteredColumns}
          dataSource={sensorList}
          pagination={false}
          className="settings-table"
        />
{SensorsPermissions?.is_create &&
        <AddItemButton
          marginTop="0px"
          fontSize="12px"
          fontWeight="600"
          text={"Add sensor"}
          onClick={handleAddProvider}
        />}
      </div>

      <CustomDeleteModal
        visible={deleteModalVisible || modalState.delete}
        onClose={() => {
          setDeleteModalVisible(false);
          setModalState((prev) => ({ ...prev, delete: false }));
        }}
        onConfirm={handleConfirmDelete}
        title={`Remove ${selectedSensor?.sensor_name && selectedSensor?.sensor_name} connection`}
        message="Are you sure you want to remove the connection? Tracking data from this sensor will no longer update in ZoomLogi."
        cancelText="Cancel"
        confirmText="Remove"
        confirmColor="#DE1135"
      />

      <CommonDrawer open={drawerOpen} onClose={handleCloseDrawer}>
        {showProviderDetails ? (
          <SensorProviderDetails
            credentials={credentials}
            getSensorImagePath={getProviderImagePath}
            setModalState={setModalState}
            providerData={{
              ...selectedSensor,
            }}
            onClose={handleCloseDrawer}
            edit={isEditing}
          />
        ) : (
          <SensorForm
            getSensorImagePath={getProviderImagePath}
            loading={sensorDDLLoading}
            sensorList={sensorFormList}
            selectedSensor={selectedSensor}
            setSelectedSensor={setSelectedSensor}
            modalOpen={modalOpen}
            setModalOpen={setModalOpen}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            showProviderDetails={showProviderDetails}
            setShowProviderDetails={setShowProviderDetails}
            token={token}
            onClose={handleCloseDrawer}
          />
        )}
      </CommonDrawer>

      <CustomModalWithoutButton
        modalOpen={modalOpen || modalState.connection}
        setModalOpen={() => {
          setModalOpen(false);
          setModalState((prev) => ({ ...prev, connection: false }));
        }}
        modalTitle={`Connect to ${selectedSensor?.name || selectedSensor?.sensor_name}`}
        modalText={`By providing API access to ZoomLogi, you're enabling ZoomLogi to retrieve your sensor information.`}
        modalSize={795}
        modalBorderRadius={"16px"}
        headerIcon={
          selectedSensor && (
            <Flex align="center" justify="center" gap={12}>
              <Avatar
                src={<img src={getProviderImagePath(selectedSensor.name || selectedSensor?.sensor_name, 'SensorImages')} alt={selectedSensor.name || selectedSensor?.sensor_name} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />}
                size={52}
                style={{
                  backgroundColor: 'transparent',
                  boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.15)',
                  borderRadius: '50%'
                }}
              />
              <img src={Arrows} alt="connects to" style={{ height: '40px' }} />
              <Avatar
                size={52}
                style={{
                  backgroundColor: 'transparent',
                  boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.15)',
                  borderRadius: '50%',
                }}
              >
                <div style={{ padding: '6px', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img src={ZLShield} alt="ZoomLogi" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                </div>
              </Avatar>
            </Flex>
          )
        }
      >
        {selectedSensor && (
          <SensorConnectionModal
            closeModal={closeModal}
            id={selectedSensor?.id}
            sensorData={selectedSensor}
            onSuccess={handleSuccess}
          />
        )}
      </CustomModalWithoutButton>
    </>
  );
};

export default Sensors;
